'use client';

import Link from 'next/link';
import { ReactNode, Fragment } from 'react';
import { XIcon, DiscordIcon } from '@/icons';
import Image from 'next/image';
import { useSynthDiscordLink } from '@/hooks/content';

type FooterSection = {
  header: string;
  links: {
    label: ReactNode;
    href: string;
  }[];
};

export const SynthFooter = () => {
  const { data: discordLink } = useSynthDiscordLink();

  return (
    <div className="flex flex-col justify-between h-[490px] relative overflow-hidden border-neutral-900 border-t">
      <div className="w-full flex flex-col items-center sm:items-start sm:flex-row justify-center gap-x-[96px] gap-y-8 z-10 bg-[linear-gradient(#000,#03030369_93%,#0303030d)] pt-8 pb-4">
        <FooterSection
          header="Get started"
          links={[
            {
              label: 'Github',
              href: 'https://github.com/mode-network/synth-subnet/',
            },
            {
              label: 'Whitepaper',
              href: 'https://mode-network.github.io/synth-subnet/Synth%20Whitepaper%20v1.pdf',
            },
            {
              label: 'Research',
              href: 'https://mirror.xyz/synthdata.eth',
            },
          ]}
        />
        <FooterSection
          header="Network"
          links={[
            {
              label: 'Dashboard',
              href: 'https://dashboard.synthdata.co/dashboard/',
            },
            {
              label: 'API',
              href: 'https://api.synthdata.co/docs',
            },
          ]}
        />
        <FooterSection
          header="Community"
          links={[
            {
              label: <XIcon className="w-6 h-6 text-white mx-auto sm:mx-0" />,
              href: 'https://x.com/SynthdataCo',
            },
            {
              label: <DiscordIcon className="w-6 h-6 text-white mx-auto sm:mx-0" />,
              href: discordLink || '',
            },
          ]}
        />
      </div>
      <Image
        className="w-full z-0 sm:pt-[120px] pt-[60px]"
        src="/synth-logo.svg"
        alt="Synth logo"
        width="1200"
        height="600"
        priority
      />
    </div>
  );
};

const FooterSection = ({ header, links }: FooterSection) => {
  return (
    <div className="text-center sm:text-left flex flex-col gap-y-2 uppercase text-sm font-medium">
      <h3 className="text-white">{header}</h3>
      {links.map((link) => (
        <Fragment key={link.href}>
          {link.href && (
            <Link className="text-grey-150" href={link.href} target="_blank">
              {link.label}
            </Link>
          )}
        </Fragment>
      ))}
    </div>
  );
};
